module.exports = __webpack_public_path__ + "72b72615e6c9e5661a8771fc42c8404c.svg";